import { Box, Breadcrumbs } from "@mui/material";

import { Header } from "~/components/DetailsPage/components/Header";
import { useSoftwareDetails } from "./hooks/useSoftwareDetails";
import { LoadingFailed, LoadingPage } from "~/components/loading";
import { SoftwareDescription } from "./AssetSoftwareDescription";
import { AssetSoftwareVulnerabilities } from "./AssetSoftwareVulnerabilities";
import { AssetSoftwareAdvisories } from "./AssetSoftwareAdvisories";
import { DynamicIcon } from "~/components/icons/DynamicIcon";
import { SpaceOrWorkspaceScope } from "~/hooks/useScope";
import { PackageIcon } from "~/icons";

type SoftwareDetailsProps = {
  scope: SpaceOrWorkspaceScope;
};

export const AssetSoftwareDetails = ({ scope }: SoftwareDetailsProps) => {
  const { assetMrn, breadcrumbs, software, stats, state, softwareMrn } =
    useSoftwareDetails({
      scope,
    });

  if (state.isLoading) {
    return <LoadingPage what="Software" />;
  }

  if (state.hasError || !software) {
    return <LoadingFailed what="Software" />;
  }

  return (
    <Box>
      <Breadcrumbs sx={{ mb: 3, overflowWrap: "anywhere" }} separator="›">
        {breadcrumbs}
      </Breadcrumbs>
      <Header
        id="software-header"
        icon={
          <DynamicIcon
            iconId={software.iconId}
            defaultIcon={PackageIcon}
            size={40}
          />
        }
        title={software.title || ""}
        created={software.firstFound}
        lastModified={software.lastUpdated}
      />
      <SoftwareDescription
        software={software}
        stats={stats}
        assetMrn={assetMrn}
      />
      <AssetSoftwareVulnerabilities
        assetMrn={assetMrn}
        softwareMrn={softwareMrn}
      />
      <AssetSoftwareAdvisories assetMrn={assetMrn} softwareMrn={softwareMrn} />
    </Box>
  );
};
